import axios from '../../utils/axios';
import CRUD from './crud'

const tournamentBookingPayments = new CRUD('tournament-booking-payments', 'superior-judge')

export default Object.assign(
    tournamentBookingPayments,
    {
        reducers: {
            ...tournamentBookingPayments.reducers
        },


        approve: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-booking-payments/${id}/approve`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        decline: (id, message=null) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-booking-payments/${id}/decline`, {
                        message
                    })
                } catch (error) {
                    console.error(error);
                }
            };
        },

        delete: (id) => {
            return async (dispatch) => {
                try {
                    return axios.delete(`/superior-judge/tournament-booking-payments/${id}/delete`)
                } catch (error) {
                    console.error(error);
                }
            };
        },
    }
)
